// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import medicalSquareIcon from "@/assets/icons/medical-square.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MedicalSquareIconProps = Omit<IconProps, "name">;

export function MedicalSquareIcon(props: MedicalSquareIconProps): React.ReactNode {
  return <Icon name={medicalSquareIcon} {...props} />;
}
